import { useCallback } from "react";
import { useFileExplorerUi } from "../../store/fileExplorerUi.store";

export function useFileExplorerPagination() {
  const { setCurrentPage, setItemsPerPage } = useFileExplorerUi();

  const handlePageChange = useCallback(
    (page: number) => {
      setCurrentPage(page);
    },
    [setCurrentPage]
  );

  const handleItemsPerPageChange = useCallback(
    (items: number) => {
      setItemsPerPage(items);
      setCurrentPage(1);
    },
    [setItemsPerPage, setCurrentPage]
  );

  return {
    handlePageChange,
    handleItemsPerPageChange,
  };
}
